import React, { useState, useEffect } from 'react';
import { BASE_URL } from './config';


const ComponentList = ({ onSelectedData }) => {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  

  useEffect(() => {
    // Effettua la chiamata API per ottenere le opzioni dal servizio REST
    // Sostituisci 'apiEndpoint' con l'effettivo endpoint del tuo servizio REST
    fetch(BASE_URL + '/util/category')
      .then(response => response.json())
      .then(data => setOptions(data))
      .catch(() => {});
  }, []); // La dipendenza vuota indica che questa chiamata API viene eseguita solo una volta al montaggio del componente


  const handleCheckboxChange = (option) => {
    const updatedOptions = selectedOptions.includes(option)
      ? selectedOptions.filter((selectedOption) => selectedOption !== option)
      : [...selectedOptions, option];
  
    setSelectedOptions(updatedOptions);
  
    // Passa i dati selezionati al componente principale utilizzando la funzione di callback
    onSelectedData(updatedOptions);
  };
  


  // ...

return (
  <div>
    <label>Seleziona opzioni:</label>
    {options.map((option) => (
      <div key={option.idCategoria} style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
        <label style={{ marginRight: '10px' }}>
          <input
            type="checkbox"
            value={option.idCategoria}
            checked={selectedOptions.includes(option)}
            onChange={() => handleCheckboxChange(option)}
          />
        </label>
        {`${option.nome} (${option.icona})`}
      </div>
    ))}
  </div>
);

};

export default ComponentList;
